module.exports = __webpack_public_path__ + "img/postgre.9c2490c8.png";